import {isNonZeroPositiveNumeric, isNumeric} from './utils.js'

export function parseNumber(value) {
  return isNumeric(value) ? Number(value) : null
}

export function parseNonZeroPositiveNumber(value) {
  return isNonZeroPositiveNumeric(value) ? Number(value) : null
}
